import React from 'react'
import boatImg from '../img/boatImg.png'

const boatArr = [
    {
        checkMark: require("../img/checkMark.svg").default,
        boatTxt: (
            <p>
                Epilog provides patients <strong>24/7 support</strong> to manage physical and emotional challenges - personalized guidance to close care gaps, improve daily living, and make informed decisions when the time is right. When escalation signals emerge, Epilog doesn't just flag them: we actively connect patients to the right care teams in their home environment, removing the friction that causes delays and dropped handoffs.
            </p>
        )
    },
    {
        checkMark: require("../img/checkMark.svg").default,
        boatTxt: (
            <p>
                Health plans and providers receive <strong>actionable data</strong> they haven't had before. Epilog delivers a timely, accurate view into each patient's needs and circumstances - so care teams can intervene efficiently, and in-person resources go where they're actually needed.
            </p>
        )
    }

]
const Boat = () => {
    return (
        <div className='boatWrap'>
             <div className="boatImg">
                    <img src={boatImg} alt="" />
                </div>
            <div class="container">
                <ul>
                    {
                        boatArr.map((boatData) => (
                            <li>
                                <img src={boatData.checkMark} alt="" />
                                <p> {boatData.boatTxt}</p>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}

export default Boat
